import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=4915bddc&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=4915bddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4915bddc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4915bddc')) {
      api.createRecord('4915bddc', component.options)
    } else {
      api.reload('4915bddc', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=4915bddc&scoped=true&", function () {
      api.rerender('4915bddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/textView/attribute.vue"
export default component.exports